<template>
  <v-dialog :value="value" @input="$emit('input', $event)" persistent max-width="450px">
    <v-card>
      <v-card-title class="headline">
        {{ type }} "{{ name }}" wirklich löschen?
      </v-card-title>
      <v-card-text>
        Diese Aktion kann nicht rückgängig gemacht werden. Alle zugehörigen Daten könnten ebenfalls entfernt werden.
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('input', false)">Abbrechen</v-btn>
        <v-btn color="red darken-1" text @click="onConfirm">Löschen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmDialog",
  props: {
    value: { type: Boolean, required: true },
    type: { type: String, default: 'Element' },
    name: { type: String, default: '' }
  },
  methods: {
    onConfirm() {
      this.$emit('confirm');
      this.$emit('input', false);
    }
  }
}
</script>